import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {FindGeoLocationService} from './find-geo-location.service';
import {Vibration} from '@ionic-native/vibration/ngx';
import {ConfigurationModel} from '../models/configuration.model';
import {DocumentTypes} from '../definitions/document-types';
import {QueueStatus} from '../definitions/queue-status';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';
import {OperatorModel} from '../models/operator.model';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class PersistDocumentService {

    config: ConfigurationModel;
    loading: any;

    constructor(private findGeoLocation: FindGeoLocationService,
                private vibration: Vibration,
                private docTypes: DocumentTypes,
                private queueStatusDefinitions: QueueStatus,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private loadingController: LoadingController) {
    }

    async loadingSpinner() {
        await this.loadingController.create({
            message: 'Saving ...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
    }


    async persistDocument(document: DocumentModel) {
        //await this.loadingSpinner();
        this.config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);

        if ( document.operator === null || !document.operator.cod ){
            document.operator = new OperatorModel();
        }
        
        document.selectedOperator = '' + this.config.selectedOperator;
        document.selectedPrinter = this.config.selectedPrinter;
        document.printerCopies = this.config.printerCopies;
        document.wasProcessed = true;

        if (!document.savedOnDevice) {
            document.savedOnDevice = new Date();
        }

        if (!document.lat || !document.lng) {
            this.findGeoLocation.getCurrentPositionCordova().then(result => {
                document.lat = result.latitude;
                document.lng = result.longitude;
            });
        }
        if (document.queuedToOperatorId) {
            document.queuedToOperatorId = document.queuedToOperatorId === -1 ? null : document.queuedToOperatorId;
        }

        if (document.documentType !== this.docTypes.SERVICEJOB) {
            // when saving contract we need to set the creation date equal to scheduled date
            if (!document.scheduledDate) {
                document.scheduledDate = document.creationDate;
            }
        }

        if (!document.queueStatus) {
            document.queueStatus = this.queueStatusDefinitions.UNSYNCED;
        }

        console.log(document);

        if (document.documentNumber !== 0) {
            document.customerRef = document.documentNumber;
            if (!this.inDocumentCollection(document)) {
                this.filterQueuedDocs(document);
                delete document.$loki;
                delete document.meta;
            }
        }
        this.stateManager.upsert('document', '$loki', document);
        this.stateManager.saveDatabase();
        this.vibration.vibrate(100);
        //this.loading.dismiss();
    }

    persistDocumentAssignment(document: DocumentModel) {

        this.config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);

        if ( document.operator === null || !document.operator.cod ){
            document.operator = new OperatorModel();
        }
        
        document.selectedOperator = '' + this.config.selectedOperator;
        document.selectedPrinter = this.config.selectedPrinter;
        document.printerCopies = this.config.printerCopies;
        document.wasProcessed = false; // we are "assigning" it to operator , he hasnt saved it himself yet

        if (!document.savedOnDevice) {
            document.savedOnDevice = new Date();
        }

        if (!document.lat || !document.lng) {
            this.findGeoLocation.getCurrentPositionCordova().then(result => {
                document.lat = result.latitude;
                document.lng = result.longitude;
            });
        }
        if (document.queuedToOperatorId) {
            document.queuedToOperatorId = document.queuedToOperatorId === -1 ? null : document.queuedToOperatorId;
        }

        if (document.documentType !== this.docTypes.SERVICEJOB) {
            // when saving contract we need to set the creation date equal to scheduled date
            if (!document.scheduledDate) {
                document.scheduledDate = document.creationDate;
            }
        }

        if (!document.queueStatus) {
            document.queueStatus = this.queueStatusDefinitions.UNSYNCED;
        }

        console.log(document);

        if (document.documentNumber !== 0) {
            document.customerRef = document.documentNumber;
            if (!this.inDocumentCollection(document)) {
                this.filterQueuedDocs(document);
                delete document.$loki;
                delete document.meta;
            }
        }
        this.stateManager.upsert('document', '$loki', document);
        this.stateManager.saveDatabase();
        this.vibration.vibrate(100);

    }




    filterQueuedDocs(document: DocumentModel) {
        // TODO remove destructive code
        if (document.documentType === 7) {
            this.stateManager.findAndRemove(this.collectionNames.SERVICEJOB, document.serviceJob.$loki);
        }
        if (document.isNewDoc) {
            delete document.isNewDoc;
            delete document.$loki;
            delete document.meta;
        }
        console.log(document);
    }


    private inDocumentCollection(document: DocumentModel) {
        const documents = this.stateManager.getCollection(this.collectionNames.DOCUMENT) as DocumentModel[];
        for (const doc of documents) {
            if (document.documentNumber === doc.documentNumber) {
                return true;
            }
        }
        return false;
    }
}
